<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="PHP Infomation">
    <template v-slot:body>
      <div class="php-center" v-html="data"></div>
    </template>
  </Body>
</template>

<script>
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'

export default {
  mixins: [Event],
  components: {
    Header,
    SideBar,
    Body
  },
  data() {
    return {
      data: ''
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    getUri() {
      return `php-infomation`
    }
  },
  methods: {
    setUpData(rawData) {
      let elem = document.createElement('div')
      elem.innerHTML = rawData
      this.data = elem.querySelector('div.center').innerHTML
    }
  }
}
</script>
<style lang="scss">
.php-center {
  text-align: center;
  pre {
    margin: 0;
    font-family: monospace;
  }

  a:link {
    color: #009;
    text-decoration: none;
    background-color: #fff;
  }

  a:hover {
    text-decoration: underline;
  }

  table {
    border-collapse: collapse;
    border: 0;
    width: 934px;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
    margin: 1em auto;
    text-align: left;
  }
  th {
    text-align: center !important;
  }

  td,
  th {
    border: 1px solid #666;
    font-size: 75%;
    vertical-align: baseline;
    padding: 4px 5px;
  }

  th {
    position: sticky;
    top: 0;
    background: inherit;
  }

  h1 {
    font-size: 150%;
  }

  h2 {
    font-size: 125%;
  }

  h2 a:link,
  h2 a:visited {
    color: inherit;
    background: inherit;
  }

  .p {
    text-align: left;
  }

  .e {
    background-color: #ccf;
    width: 300px;
    font-weight: bold;
  }

  .h {
    background-color: #99c;
    font-weight: bold;
  }

  .v {
    background-color: #ddd;
    max-width: 300px;
    overflow-x: auto;
    word-wrap: break-word;
  }

  .v i {
    color: #999;
  }

  img {
    float: right;
    border: 0;
  }

  hr {
    width: 934px;
    background-color: #ccc;
    border: 0;
    height: 1px;
  }

  :root {
    --php-dark-grey: #333;
    --php-dark-blue: #4f5b93;
    --php-medium-blue: #8892bf;
    --php-light-blue: #e2e4ef;
    --php-accent-purple: #793862;
  }
}
</style>
